import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMapPointer20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconMapPointer20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M15.5 7.923c0 1.956-1.035 4.425-2.44 6.484-.689 1.009-1.417 1.845-2.056 2.41a4.4 4.4 0 0 1-.797.584c-.09.05-.153.075-.19.088a1.4 1.4 0 0 1-.192-.088 4.6 4.6 0 0 1-.802-.587c-.643-.565-1.375-1.402-2.067-2.41C5.54 12.344 4.5 9.876 4.5 7.924 4.5 4.946 6.951 2.5 10.018 2.5c3.056 0 5.482 2.437 5.482 5.423m1.5 0C17 12.7 12.123 19 10.018 19S3 12.7 3 7.923C3 4.1 6.142 1 10.018 1S17 4.1 17 7.923m-5.75-.173a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m1.5 0a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMapPointer20);
